import React from 'react'
import ReportWrapper from '../ReportWrapper'
import ReportSectionHeading from '../ReportSectionHeading'
import ReportItem from '../ReportItem'

interface MarriageInformationProps {
  data: any
  title: string
  sectionIndex?: string
}

export default function MarriageInformation({ data, title, sectionIndex }: MarriageInformationProps) {
  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      <div className="mt-2">
        <ReportItem name={'婚姻状态'} value={data?.marriage_info || '—'} />
      </div>
    </ReportWrapper>
  )
}
